function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJackpot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 23 23",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.414,11.05C16.874,9.912 16.231,8.959 15.465,8.223C14.717,7.487 13.952,6.784 13.204,6.132C12.456,5.48 11.795,4.777 11.256,4.041C10.716,3.305 10.438,2.519 10.438,1.683C10.438,1.147 10.177,0.813 9.655,0.662C9.133,0.512 8.716,0.662 8.403,1.114C7.602,2.218 7.046,3.205 6.715,4.125C6.385,5.028 6.28,5.797 6.367,6.416C6.454,7.035 6.646,7.604 6.941,8.106C7.237,8.608 7.602,9.076 8.055,9.477C8.507,9.896 8.924,10.297 9.325,10.682C9.377,10.732 9.412,10.799 9.446,10.832L14.126,10.832C15.083,10.832 15.865,11.585 15.865,12.505L15.865,16.754C15.865,17.674 15.083,18.426 14.126,18.426L4.645,18.426C3.688,18.426 2.905,17.674 2.905,16.754L2.905,12.505C2.905,11.585 3.688,10.832 4.645,10.832L4.889,10.832L4.889,9.611C4.889,9.109 4.662,8.758 4.193,8.591C3.723,8.407 3.323,8.507 2.992,8.858C1.288,10.548 0.453,12.555 0.453,14.863C0.453,17.172 1.322,19.212 3.062,20.885C4.802,22.558 6.889,23.394 9.325,23.394C11.76,23.394 13.847,22.558 15.587,20.885C17.327,19.212 18.196,17.205 18.196,14.863C18.196,13.475 17.918,12.204 17.379,11.066L17.414,11.05Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.068,5.576C21.253,5.576 22.214,4.652 22.214,3.512C22.214,2.372 21.253,1.448 20.068,1.448C18.882,1.448 17.921,2.372 17.921,3.512C17.921,4.652 18.882,5.576 20.068,5.576Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.562,
    y: 5.038,
    width: 1.011,
    height: 7.438,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.656,12.477L18.479,12.477C17.435,12.477 16.588,13.291 16.588,14.295L16.588,14.786C16.588,15.79 17.435,16.605 18.479,16.605L21.656,16.605C22.701,16.605 23.547,15.79 23.547,14.786L23.547,14.295C23.547,13.291 22.701,12.477 21.656,12.477Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.605,12.477L7.103,12.477L7.103,13.258C6.803,13.53 6.538,13.802 6.343,14.108C6.096,14.481 5.902,14.889 5.76,15.348C5.654,15.704 5.566,16.129 5.531,16.605L4.329,16.605C4.418,15.925 4.577,15.365 4.771,14.906C4.965,14.447 5.283,13.955 5.725,13.445L3.605,13.445L3.605,12.477Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.826,12.477L15.324,12.477L15.324,13.258C15.024,13.53 14.759,13.802 14.564,14.108C14.317,14.481 14.123,14.889 13.981,15.348C13.875,15.704 13.787,16.129 13.752,16.605L12.55,16.605C12.639,15.925 12.798,15.365 12.992,14.906C13.186,14.447 13.504,13.955 13.946,13.445L11.826,13.445L11.826,12.477Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.716,12.477L11.213,12.477L11.213,13.258C10.913,13.53 10.648,13.802 10.454,14.108C10.206,14.481 10.012,14.889 9.871,15.348C9.765,15.704 9.677,16.129 9.641,16.605L8.44,16.605C8.528,15.925 8.687,15.365 8.882,14.906C9.076,14.447 9.394,13.955 9.836,13.445L7.716,13.445L7.716,12.477Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJackpot);
export default __webpack_public_path__ + "static/media/jackpot.6d75c975.svg";
export { ForwardRef as ReactComponent };